import { homeRoutes } from "./home-routes";

export default (router: any) => {
  homeRoutes.forEach((route: any) => {
    router.addRoute(route);
  });
};
